// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxFilterBody from '../checkbox-filter/checkbox-filter-body';
import {FormattedMessage} from 'react-intl';
import TranslatedInput from '../../translated-input';

function handleInputChange(event) {

    this.onInputChange(event.target.value);

}

const CheckboxWithSearchFilterBody = props =>
    <section className='checkbox-with-search-filter-body'>
        <div className='rounded-bar'>
            <span className='icon-search'/>
            <TranslatedInput
                className='rounded-input'
                onChange={handleInputChange.bind(props)}
                placeholder={props.searchPlaceholder}
                type='text'
                value={props.searchInput}
            />
        </div>
        {
            props.list.length > 0 ?
                <CheckboxFilterBody
                    initialState={props.initialState}
                    list={props.list}
                    minNumberOfItems={props.minNumberOfItems}
                    onChange={props.onCheckboxListChange}
                    onToggleAll={props.onToggleAll}
                    valueKey={props.valueKey}
                /> :
                    <FormattedMessage id='NO_MATCHING_DEALERS'/>
        }
    </section>;

CheckboxWithSearchFilterBody.displayName = 'CheckboxWithSearchFilterBody';

CheckboxWithSearchFilterBody.propTypes = {
    initialState: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    minNumberOfItems: PropTypes.number,
    onCheckboxListChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired,
    searchInput: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
    valueKey: PropTypes.string.isRequired
};

export default CheckboxWithSearchFilterBody;



// WEBPACK FOOTER //
// ./src/shared/components/facets/checkbox-with-search-filter/checkbox-with-search-filter-body.js